import React, { useState } from 'react';
import { useSpring } from 'react-spring';
import { Flexbox, FlexboxColumn } from '../../components/action/Flexbox';
import SearchBar from '../../components/action/SearchBar';
import Tooltip from '../../components/action/TooltipWrapper';
import ChainDropdown from '../../components/Filters/ChainDropdown';
import TableComponent from '../../components/TableContainer/TableContainer';
import ThemedText from '../../components/theme/ThemedText';
import ThemeLogo from '../../components/theme/ThemeLogo';
import UserReputation from '../../components/UserReputation/UserReputation';
import { useMrepState } from '../../helpers/mrepHelper';

const ProjectReputation = () => {
  const springProps = useSpring({
    from: { transform: 'translateY(-25px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    config: { tension: 200, friction: 20 },
  });

  const [searchTerm, setSearchTerm] = useState();

  const [{ protocolRanking, protocolActionStats, protocolFilter, setValue, protocolRankingLoading }] = useMrepState();

  function updateAction(value) {
    setValue('protocolFilter', { ...(protocolFilter || {}), actionType: value });
  }

  function updateChain(value) {
    setValue('protocolFilter', { ...(protocolFilter || {}), chainId: value });
  }

  return (
    <FlexboxColumn fw style={springProps}>
      <Flexbox fw justifyContent='space-between'>
        <Flexbox gap='0.5rem'>
          <ThemedText.H4 weight={'semi-bold'}>Project Stats </ThemedText.H4>
          <Tooltip
            content={
              'Project Stats reflects your interaction and contribution to different projects across the blockchain ecosystem. Your historical volume and deposits in a protocol are tracked and compared with others to generate the rankings of your contributions.'
            }
            position={'right'}
          >
            <ThemeLogo icon={'info'} />
          </Tooltip>
        </Flexbox>
        <Flexbox>
          <ChainDropdown onChange={updateChain} filter={protocolFilter?.chainId} />
          <SearchBar placeholder='Search Projects' value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
        </Flexbox>
      </Flexbox>
      <UserReputation data={protocolActionStats} filter={protocolFilter?.actionType} onChange={updateAction} />
      <TableComponent data={protocolRanking} key={'protocolRanking '} name={'Project'} isLoading={protocolRankingLoading} searchTerm={searchTerm} />
    </FlexboxColumn>
  );
};

export default ProjectReputation;
